// Topic IDs and slugs stay stable so existing links and interactions keep their topic.
export const topicCatalog = [
  {
    id: '10000000-0000-4000-8000-000000000003',
    slug: 'ksf-reliability-modelling',
    title: 'KSF LEDs for challenging applications need dedicated LED release QTP',
    presenter: 'Rene, Research',
    discussionQuestion: 'KSF LEDs for challenging applications need dedicated LED release QTP',
    discussionOptions: [
      'Good idea to do this, it makes sense',
      'Don’t do this, too much effort for too limited benefits',
      'Don’t do this, it will always remain too risky',
      'Don’t do this, just use normal LED QTP and if it goes wrong we will see then',
    ],
  },
  {
    id: '10000000-0000-4000-8000-000000000002',
    slug: 'ai-for-light-sources',
    title: 'AI-Assisted LED Change Review',
    presenter: 'Hannah, GPP',
    discussionQuestion: 'How should engineers review report from LED supplier?',
    discussionOptions: [
      'Trust supplier’s claim',
      'Engineer review checklist line by line',
      'Believe AI Review recommendation',
      'AI Review recommendation with engineer confirmation',
    ],
  },
  {
    id: '10000000-0000-4000-8000-000000000001',
    slug: 'fibr8-laser-led-fiber-lighting',
    title: 'Opportunities for Laser/LED fibre lighting',
    presenter: 'Alexander Vdovin, Research',
    discussionQuestion: null,
    discussionOptions: [],
  },
  {
    id: '10000000-0000-4000-8000-000000000004',
    slug: '5050flipchip-super-robust-package',
    title: 'What’s the key bottleneck of 5050 to fully replace HP for Outdoor application',
    presenter: 'Zhen Yi, GPP',
    discussionQuestion: 'What’s the key bottleneck for 5050 to fully replace HP?',
    discussionOptions: [
      'Due to lifetime advantage?',
      'Due to reliability considerations?',
      "Due to HP's optical design friendliness?",
      "Due to HP's full-color product offering?",
      'Due to other….',
    ],
  },
  {
    id: '10000000-0000-4000-8000-000000000006',
    slug: 'multi-cup-led-reliability',
    title: 'Multi-cup LEDs – weaker mechanical structure and bring new reliability challenges',
    presenter: 'Summy, CLED',
    discussionQuestion: 'Work with LED package suppliers to finetune the process\nWork with LED PKG suppliers & L/F makers to optimize L/F design',
    discussionOptions: [
      'Good idea to do this, it makes sense',
      'Don’t do this, since it takes too much effort and cost lots of money & resources',
      'Don’t do this, keep same reliability level as competitor is good enough',
      'Don’t do this, just focus on cost down solution to have higher margins',
    ],
  },
  {
    id: '10000000-0000-4000-8000-000000000007',
    slug: '2835pct-3d-54v-s-phosphor-leds',
    title: '2835PCT 3D 54V S phosphor LEDs- Great reliability challenges',
    presenter: 'Yong Yang, CLED',
    discussionQuestion: 'Optimize process/chips layout and use bigger size LF(such as 3035PCT)\nReduce the power from 1.1W(54V 20mA) to 0.55W(54V 10mA), the actual application is 0.3W(54V 5mA)',
    discussionOptions: [
      'Good idea to do this, it makes sense',
      'Don’t do this, too much effort for too limited benefits',
      'Don’t do this, it can’t improve the reliability',
      'Don’t do this, there will be better solutions to improve the reliability',
    ],
  },
  {
    id: '10000000-0000-4000-8000-000000000008',
    slug: 'uniform-color-between-luminaires',
    title: 'Uniform Color Across Luminaires: 4-SKU Offset Strategy',
    presenter: 'John Yeh, Prof EM',
    discussionQuestion: 'What cross-family color consistency target should we aim for, and why?',
    discussionOptions: [
      '7 SDCM',
      '5 SDCM',
      '3 SDCM',
      'Other SDCM— please specify.',
    ],
  },
  {
    id: '10000000-0000-4000-8000-000000000009',
    slug: 'cct-shift-during-led-lifetime',
    title: 'CCT shift during LED lifetime',
    presenter: 'Alexander Beraldo, Prof EM',
    discussionQuestion: 'Can LED package data be applied to LED lamps and luminaires?\nAre there any methods for projecting color shift over time using measured data?\nHow should end users and/or specifiers can monitor color over time in the field?',
    discussionOptions: [],
  },
  {
    id: '10000000-0000-4000-8000-000000000010',
    slug: 'mygraine-green-light',
    title: 'MyGraine Light à Green Light to reduce pain / improve comfort',
    presenter: 'Remy, Research',
    discussionQuestion: 'Do you know people that suffer from migraine?\nWould a lamp that gives comfort and connection be valuable in your opinion?',
    discussionOptions: [],
  },
];
